import { prop } from 'ramda';
import { useMemo } from 'react';
import * as server from '../../user/server';
import { useUserSelector } from 'js/store/hooks';
import { useUserPublicAPI as useCoreUserPublicAPI } from 'js/hooks/usePublicAPI/hooks/useUserPublicAPI';

const notLoggedIn = () => Promise.reject(new Error('User Public API: User must be logged in.'));

export const removePlayerTags = isLoggedIn => (tags = [], isForce) => {
    if (!isLoggedIn && !isForce) {
        return notLoggedIn();
    }

    return server.removePlayerTags(tags);
};

export const useUserPublicAPI = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const corePublicAPIMethods = useCoreUserPublicAPI();

    return useMemo(() => ({
       ...corePublicAPIMethods,
        /**
         * Remove tags for a current player.
         * @memberOf Playtech.API.user
         * @function
         * @param [tags=[]] {Array} list of tags
         */
        removePlayerTags: removePlayerTags(isLoggedIn)
    }), [isLoggedIn, corePublicAPIMethods]);
};
